import cn from "classnames"
import { Field, FieldProps } from "formik"
import React from "react"
import { useTranslation } from "react-i18next"

import { FormButton } from "~/components/Button/Button"
import { agreementFileName, policyFileName } from "~/components/PolicyFile/PolicyFile"

import styles from "./index.module.css"

type Props = {
  buttonLabel?: string
  className?: string
}

export const FormSubmitSection: React.FC<Props> = ({ buttonLabel, className }) => {
  const { t } = useTranslation()
  const label = buttonLabel ?? t("popup.Default.Form.SendButton")
  const agreementName = agreementFileName()
  const policyName = policyFileName()

  return (
    <Field name="agreePolicy" type="checkbox">
      {({ field, form: { isValid } }: FieldProps) => {
        const agreed = !!field.value

        return (
          <div className={cn(styles.Wrapper, className)}>
            <FormButton disabled={!agreed || !isValid} view="xl">
              {label}
            </FormButton>

            <div className={styles.PolicyWrapper}>
              <div className={styles.Top}>
                <div className={styles.CheckboxWrapper}>
                  <label className={cn(styles.Label, agreed && styles.LabelChecked)}>
                    <input {...field} checked={agreed} className={styles.Input} type="checkbox" />
                  </label>
                </div>

                <div
                  className={styles.PolicyMessage}
                  dangerouslySetInnerHTML={{
                    __html: t("PolicyMessage", {
                      buttonName: label,
                      fileName: agreementName,
                      secondFileName: policyName,
                    }),
                  }}
                />
              </div>

              <div
                className={styles.SecondText}
                dangerouslySetInnerHTML={{
                  __html: t("PolicyLink", { secondFileName: policyName }),
                }}
              />
            </div>
          </div>
        )
      }}
    </Field>
  )
}
